import { getIdOrNull } from '..'
import apiClient from './apiClient'

const fetchInsitutionContactPersons = (user, institution, queryParams) => apiClient
  .get(user, `api/institutions/${getIdOrNull(institution)}/contact-persons`, queryParams)

const fetchSchoolContactPersons = (user, school, queryParams) => apiClient
  .get(user, `api/schools/${getIdOrNull(school)}/contact-persons`, queryParams)

const fetchSchoolSectionsLinkedToContactPersons = (user, school) => apiClient
  .get(user, `api/schools/${getIdOrNull(school)}/school-sections?withContactPerson=1`)

const DEFAULT_PARAM_UPDATE_CONTACT_PERSON = { id: -1, email: '', lastname: '', firstname: '', phone: '' }
const updateContactPerson = (userToUpdate = DEFAULT_PARAM_UPDATE_CONTACT_PERSON, user) => {
  const body = {
    email: userToUpdate.email,
    lastname: userToUpdate.lastname,
    firstname: userToUpdate.firstname,
    phone: userToUpdate.phone
  }

  return apiClient.patch(
    user,
    `api/users/${getIdOrNull(userToUpdate)}`,
    body
  )
}

export {
  fetchInsitutionContactPersons,
  fetchSchoolContactPersons,
  fetchSchoolSectionsLinkedToContactPersons,
  updateContactPerson
}
